document.addEventListener('DOMContentLoaded', () => {
  const stickyAtc = document.querySelector('.sticky-atc') || document.getElementById('sticky-atc');
  const mainAtc = document.querySelector('.wt-product__add-to-cart');
  const header = document.querySelector('.wt-header__body');

  if (stickyAtc && mainAtc) {
    const headerHeight = header ? header.offsetHeight : 0;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyAtc.classList.remove('show');
          } else {
            stickyAtc.classList.add('show');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
      }
    );

    observer.observe(mainAtc);
  }

  if (!stickyAtc) return;

  const sectionId = stickyAtc.dataset.sectionId;
  const productHandle = stickyAtc.dataset.productHandle;

  if (!sectionId || !productHandle) return;

  const variantOptionsEl = document.querySelector(
    `variant-options[data-section="${sectionId}"][data-product-handle="${productHandle}"]`
  );

  if (!variantOptionsEl) return;

  const variantsJsonEl = variantOptionsEl.querySelector('script[type="application/json"]');
  if (!variantsJsonEl) return;

  const variants = JSON.parse(variantsJsonEl.textContent || '[]');

  const stickyRadios = stickyAtc.querySelectorAll('.sticky-atc__variant-radio');
  const stickySelect = stickyAtc.querySelector('.sticky-atc__variant-select');

  function findVariantById(id) {
    const numericId = Number(id);
    return variants.find((v) => v.id === numericId);
  }

function syncMainVariantOptionsToVariant(variant) {
  if (!variant || !variantOptionsEl) return;

  const optionValues = variant.options || [];

  const optionFieldsets =
    variantOptionsEl.querySelectorAll('.wt-product__option');

  optionFieldsets.forEach((fieldset, index) => {
    const targetValue = optionValues[index];

    if (!targetValue) return;

    const targetRadio = fieldset.querySelector(
      `input[type="radio"][value="${CSS.escape(targetValue)}"]`
    );

    if (!targetRadio) return;

  
    if (targetRadio.checked) return;

    targetRadio.checked = true;

    targetRadio.dispatchEvent(
      new Event('change', {
        bubbles: true,
      })
    );
  });
}

  stickyRadios.forEach((radio) => {
    radio.addEventListener('change', (event) => {
      if (!event.target.checked) return;
      const variantId = event.target.dataset.variantId || event.target.value;
      const variant = findVariantById(variantId);
      if (!variant) return;
      syncMainVariantOptionsToVariant(variant);
    });
  });

  if (stickySelect) {
    stickySelect.addEventListener('change', (event) => {
      const variantId = event.target.value;
      const variant = findVariantById(variantId);
      if (!variant) return;
      syncMainVariantOptionsToVariant(variant);
    });
  }

  const mainForm = document.getElementById(`product-form-${sectionId}`);
  const stickyForm = document.getElementById(`product-form-sticky-${sectionId}`);

  if (mainForm && stickyForm) {
    const mainQtyInput = mainForm.querySelector('input[name="quantity"]');
    const stickyQtyInput = stickyForm.querySelector('input[name="quantity"]');

    if (mainQtyInput && stickyQtyInput) {
      stickyQtyInput.value = mainQtyInput.value;

      let isSyncingQty = false;

      function syncQuantity(fromInput, toInput) {
        if (isSyncingQty) return;
        isSyncingQty = true;

        toInput.value = fromInput.value;
        toInput.dispatchEvent(new Event('change', { bubbles: true }));

        isSyncingQty = false;
      }

      ['input', 'change'].forEach((evt) => {
        mainQtyInput.addEventListener(evt, () => {
          syncQuantity(mainQtyInput, stickyQtyInput);
        });
      });

      ['input', 'change'].forEach((evt) => {
        stickyQtyInput.addEventListener(evt, () => {
          syncQuantity(stickyQtyInput, mainQtyInput);
        });
      });
    }
  }
});